import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {TranslocoService} from "@ngneat/transloco";
import {ContainerService, StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn, ITableListEvent} from "../../../../components/table-list-input/table-list-input.component";
import {actionSceneItemPlaylist} from "../../../../store/actions/user.actions";
import {Lib} from "../../../../../libs/Lib";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import {IPage} from "../../../../interfaces";
import {getTotalLengthPlaylist, isNullOrUndef, MAX_PLAYLIST_TIME} from "../../../../common";
import {ToastrService} from 'ngx-toastr';
import {filter, map, take} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {faPlayCircle} from "@fortawesome/free-solid-svg-icons";
import {ITableIconPipe} from "../../../../pipes/table-list-icon-pipe";
import * as _ from "lodash";

@Component({
    selector: 'app-block-scene-loader',
    templateUrl: './block-scene-loader.component.html',
    styleUrls: ['./block-scene-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockSceneLoaderComponent extends BlockBaseComponent {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];

    private static onCallBackFaIcon(v: ITableIconPipe) {
        if (v.index === 0) return faPlayCircle;
        return null;
    }

    constructor(private translocoService: TranslocoService,
                public override storeSelector: StoreSelectorsService,
                private toastr: ToastrService,
                public override dialog: MatDialog,
                private containerService: ContainerService,
                public cd: ChangeDetectorRef
    ) {
        super(storeSelector, dialog);
        /*
        this.tableColumns = [{
            inputType: 'edit',
            name: 'page',
            maxStringSize: '16'
        }, {
            inputType: 'text',
            name: 'type',
            maxStringSize: '16'
        }, {
            inputType: 'edit',
            name: 'duration',
            maxStringSize: '10'
        }];

        this.buttons = [
            // {
            //     callBack: v => (v),
            //     icon: 'device_hub',
            //     name: 'list',
            //     disableByList: false,
            //     disabled: false,
            //     tooltip: this.translocoService.translate('general.playlistTimeline', {}, this.translocoService.getActiveLang())
            // },
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                confirmRemove: this.translocoService.translate('toast.sureWantItem', {}, this.translocoService.getActiveLang()),
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
        */
    }

    // onPlaylistTimeline() {
    //     this.containerService.updateEditorMode('sceneLoaderMode');
    // }

    override componentInit() {
        super.componentInit();
        const playlistIndexes$ = this.storeSelector.listenSelectedScenePlaylist();
        const sceneUpdate$ = this.storeSelector.listenPlayersOfScene(this.sceneId);
        this.cod(
            combineLatest([playlistIndexes$, this.containerService.editorMode, sceneUpdate$]).pipe(
                map(([indexes, containerServiceMode, sceneUpdate]) => {
                    if (containerServiceMode === 'collectionMode') return indexes;
                    return null;
                }),
                filter((v) => v !== null)
            ).subscribe((indexes) => {
                super.initApplyStoreToDynamic(true);
                this.tableListSelection('Page', indexes);
                this.cd.detectChanges();
            })
        );
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.cd.markForCheck();
        // super.initApplyStoreToDynamic(true);
    }

    updateTransition() {
    }

    private onTableListChangeCallBack(e: ITableListEvent) {
        if (e.currentAction === 'selected') {
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'previous' || e.currentAction === 'next') {
            // this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'rename') {
            const oldPages = this.sceneItem.Data[0].SceneLoader[0].Page;
            const pages = e.values;
            if (pages && _.isArray(pages)) {
                const len = getTotalLengthPlaylist(pages);
                if (len > MAX_PLAYLIST_TIME) {
                    this.showToastOverLength();
                    // this.storeSelector.dispatch({type: 'UNDO'});
                    this.dispatchSceneItemChanges({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'Page',
                            value: oldPages,
                            storePath: 'Data[0].SceneLoader[0]'
                        }]
                    });
                    super.initApplyStoreToDynamic(true);
                }
            }
        } else if (e.currentAction === 'drop' || e.currentAction === 'removed') {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Page',
                    value: e.values,
                    storePath: 'Data[0].SceneLoader[0]'
                }]
            });
        } else if (e.currentAction === 'added') {
            this.openAssociateDialog(true, 'Page');
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
        }
    }

    override submit(formValues) {
        super.submit(formValues);
        // if (this.onFormSubmitAction(formValues)) {
        //     super.submit(formValues);
        // }
    }

    private onFormSubmitAction(e): boolean {
        let returnVal = null;
        Object.entries(e).map((items: Array<any>) => {
            const tableName = items[0];
            items.forEach((val: ITableListEvent) => {
                if (isNullOrUndef(val?.currentAction)) return returnVal = true;
                Lib.DevShow(`>>> onFormSubmitAction ${tableName} | ${val.currentAction}| selected ${val.selected.length} | values ${val.values.length}`);
                switch (val.currentAction) {
                    case 'selected':
                    case 'externallySelected': {
                        return returnVal = false;
                    }
                    case 'list': {
                        // this.onPlaylistTimeline();
                        return returnVal = false;
                    }
                    case 'added': {
                        this.openAssociateDialog(true, tableName);
                        this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
                        return returnVal = true;
                    }
                    case 'removed':
                    case 'rename': {
                        return returnVal = true;
                    }
                    default: {
                        return returnVal = true;
                    }
                }
            });
        });
        return returnVal;
    }

    openAssociateDialog(addingNew, tableName: 'pageGps' | 'Page') {
        const data: IDialogGetAsset = {mode: "SCENE_RESOURCE:PLAYER", mimeType: SceneMimeTypes.Player};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAsset: IDialogGetAsset) => {
                    if (!dialogGetAsset?.selectedType) return;
                    this.addTableItem(dialogGetAsset);
                })
        );
    }

    addTableItem(dialogGetAsset: IDialogGetAsset) {
        let pager: IPage;
        switch (dialogGetAsset.selectedType) {
            case "RESOURCE_SELECTED": {
                const resource_type = dialogGetAsset.sourceData.resource_type;
                const playerId = (["mp4", "mov", "m4v", "3gp"].indexOf(resource_type) > -1) ? "3100" : "3130";

                pager = {
                    $: {
                        page: `${dialogGetAsset.sourceData.resource_name}`,
                        type: "resource",
                        duration: "5"
                    },
                    Player: [
                        {
                            "$": {
                                player: playerId,
                                id: _.uniqueId('__')
                            },
                            Data: [
                                {
                                    Resource: [
                                        {
                                            $: {
                                                resource: dialogGetAsset.selected
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                };
                break;
            }
            case "SCENE_SELECTED": {
                pager = {
                    $: {
                        page: dialogGetAsset.sourceData.Player.$.label,
                        type: "scene",
                        duration: "5"
                    },
                    Player: [
                        {
                            $: {
                                src: dialogGetAsset.selected
                            }
                        }
                    ]
                };
                break;
            }
        }
        const pages = this.sceneItem.Data[0].SceneLoader[0].Page && _.isArray(this.sceneItem.Data[0].SceneLoader[0].Page) ? _.cloneDeep(this.sceneItem.Data[0].SceneLoader[0].Page) : [];
        let len = getTotalLengthPlaylist(pages);
        if (pager.$.duration) {
            len += parseFloat(pager.$.duration);
        }
        if (len > MAX_PLAYLIST_TIME) {
            this.showToastOverLength();
            return;
        }
        pages.push(pager);
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: pages,
                storePath: 'Data[0].SceneLoader[0]'
            }]
        });
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            // {
            //     type: "input",
            //     value: '',
            //     label: this.translocoService.translate('general.playlistName', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "label",
            //     storePath: '$.label'
            // } // ,
            // {
            //     type: "input",
            //     value: '',
            //     min: '1',
            //     max: '999',
            //     label: this.translocoService.translate('general.duration', {}, this.translocoService.getActiveLang()),
            //     inputType: "number",
            //     name: "duration",
            //     storePath: 'Data[0].SceneLoader[0].$.duration'
            // }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
            // ,
            // {
            //     type: "input",
            //     label: '',
            //     inputType: 'tablelist',
            //     tableColumns: this.tableColumns,
            //     ignoreMissingValue: true,
            //     cloneVals: true,
            //     multiSelect: false,
            //     rememberSelection: false,
            //     allowFilter: true,
            //     buttonBarClassName: 'playlistButtonBar',
            //     buttons: this.buttons,
            //     inputEditFormat: {page: 'text', duration: 'number'},
            //     inputEditRenamePath: [{path: '$.page', key: 'page'}, {path: '$.type', key: 'type'}, {path: '$.duration', key: 'duration'}],
            //     name: "Page",
            //     storePath: 'Data[0].SceneLoader[0].Page',
            //     callBackEvent: (v) => this.onTableListChangeCallBack(v)
            //     // callBackFaIcon: (v) => BlockPlaylistComponent.onCallBackFaIcon(v),
            // }
        ];
    }

    private showToastOverLength() {
        this.toastr.error(this.translocoService.translate('general.tooLong24', {}, this.translocoService.getActiveLang()));
    }

}
